// Физический размер растрового слоя при импорте: DPI из метаданных файла.
// Разбираем PNG pHYs и JPEG JFIF по байтам; при отсутствии/мусоре — null
// (сработает fallback DEFAULT_IMPORT_DPI). Чистый модуль без DOM.

export const DEFAULT_IMPORT_DPI = 300

// Пиксели → мм при заданном DPI.
export const physicalMmFromPx = (px, dpi) => (px / dpi) * 25.4

// Экранные дефолты (72/96) и абсурд считаем «DPI не задан».
const MIN_TRUSTED_DPI = 97
const MAX_TRUSTED_DPI = 2400

function sane(x, y) {
  if (!(x > 0) || !(y > 0)) return null
  if (x < MIN_TRUSTED_DPI || y < MIN_TRUSTED_DPI) return null
  if (x > MAX_TRUSTED_DPI || y > MAX_TRUSTED_DPI) return null
  return { x: Math.round(x), y: Math.round(y) }
}

// PNG: сигнатура + скан чанков до pHYs (идёт раньше IDAT).
function pngDpi(view) {
  const sig = [137, 80, 78, 71, 13, 10, 26, 10]
  if (view.byteLength < 8) return null
  for (let i = 0; i < 8; i++) if (view.getUint8(i) !== sig[i]) return null
  let off = 8
  while (off + 8 <= view.byteLength) {
    const len = view.getUint32(off)
    const type = String.fromCharCode(
      view.getUint8(off + 4), view.getUint8(off + 5),
      view.getUint8(off + 6), view.getUint8(off + 7)
    )
    if (type === "pHYs") {
      if (off + 8 + 9 > view.byteLength) return null
      const unit = view.getUint8(off + 16)
      if (unit !== 1) return null                     // 0 = только соотношение
      return { x: view.getUint32(off + 8) * 0.0254, y: view.getUint32(off + 12) * 0.0254 }
    }
    if (type === "IDAT") return null                  // pHYs идёт до IDAT
    off += 12 + len                                   // len(4)+type(4)+data(len)+crc(4)
  }
  return null
}

// JPEG: SOI + скан сегментов до APP0 JFIF (или до SOS).
function jpegDpi(view) {
  if (view.byteLength < 4 || view.getUint16(0) !== 0xffd8) return null
  let off = 2
  while (off + 4 <= view.byteLength) {
    if (view.getUint8(off) !== 0xff) return null
    const marker = view.getUint8(off + 1)
    if (marker === 0xda) return null                  // SOS — начались данные
    const size = view.getUint16(off + 2)
    if (marker === 0xe0 && off + 18 <= view.byteLength &&
        view.getUint8(off + 4) === 0x4a && view.getUint8(off + 5) === 0x46 &&
        view.getUint8(off + 6) === 0x49 && view.getUint8(off + 7) === 0x46 &&
        view.getUint8(off + 8) === 0x00) {
      const units = view.getUint8(off + 11)
      const xd = view.getUint16(off + 12)
      const yd = view.getUint16(off + 14)
      if (units === 1) return { x: xd, y: yd }         // dpi
      if (units === 2) return { x: xd * 2.54, y: yd * 2.54 } // dpcm
      return null                                      // 0 = соотношение
    }
    off += 2 + size
  }
  return null
}

export function rasterDpi(buffer) {
  if (!buffer || buffer.byteLength < 8) return null
  const view = new DataView(buffer)
  const raw = pngDpi(view) || jpegDpi(view)
  return raw ? sane(raw.x, raw.y) : null
}
